function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault;


//////////////////
// WEBPACK FOOTER
// ./~/redux-inputs/~/@babel/runtime/helpers/interopRequireDefault.js
// module id = 58
// module chunks = 0